import { UserResponse, UserRole, UserStatus } from './../../entities/account/UserResponse';

export function isAdmin(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin : false;
}

export function isStaff(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin || user.role === UserRole.user : false;
}

export function isClient(user?: UserResponse | null) {
  return user ? user.role === UserRole.client : false;
}

export function statusLabel(type: UserStatus) {
  switch (type) {
    case UserStatus.active:
      return 'Active';
    case UserStatus.inActive:
      return 'In-Active';
  }
}

export function allUserStatuses() {
  return [UserStatus.active, UserStatus.inActive];
}

export function getStatusItems() {
  return allUserStatuses().map(type => ({
    value: type,
    label: statusLabel(type),
  }));
}
